/* eslint-disable no-mixed-operators */
const easeInOutCubic = (time, offset, end, duration) => {
  const cc = end - offset;
  let tempTime = time / (duration / 2);

  if (tempTime < 1) {
    return (cc / 2) * tempTime ** 3 + offset;
  }
  tempTime = tempTime -= 2;

  return (cc / 2) * (tempTime ** 3 + 2) + offset;
};

export const setScrollTop = (ele, end) => {
  const start = ele.scrollTop;
  const startTime = Date.now();

  const frameFunc = () => {
    const timestamp = Date.now();
    const time = timestamp - startTime;
    const top = easeInOutCubic(time, start, end, 450);

    ele.scrollTop = top;
    if (time < 450) {
      requestAnimationFrame(frameFunc);
    }
  };

  requestAnimationFrame(frameFunc);
};

export default {
  setScrollTop,
};
